(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sell-count"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sell-count')) {
    customElements.define(
      'product-sell-count',
      class ProductSellCount extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          const storageKey = `product-sell-count-${this.dataset.productId}`;
          const persist = !(window.Shopify && window.Shopify.designMode);

          try {
            if (persist && sessionStorage.getItem(storageKey) === 'closed') {
              this.hidden = true;
              return;
            }
          } catch (error) {}

          const dismiss = () => {
            if (this.hidden || this.classList.contains('is-dismissing')) return;
            window.clearTimeout(this.dismissTimer);
            this.classList.add('is-dismissing');
            window.setTimeout(() => {
              this.hidden = true;
            }, 400);
            if (!persist) return;
            try {
              sessionStorage.setItem(storageKey, 'closed');
            } catch (error) {}
          };

          this.querySelector('.product-sell-count__close')?.addEventListener('click', dismiss);

          if (persist) {
            this.dismissTimer = window.setTimeout(dismiss, 3000);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
